import { render, staticRenderFns } from "./PrivateSchool.vue?vue&type=template&id=c8285fec&scoped=true&"
import script from "./PrivateSchool.vue?vue&type=script&lang=js&"
export * from "./PrivateSchool.vue?vue&type=script&lang=js&"
import style0 from "./PrivateSchool.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PrivateSchool.vue?vue&type=style&index=1&id=c8285fec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8285fec",
  null
  
)

export default component.exports